module.exports = __webpack_public_path__ + "static/media/notAvailable.de3709e6.svg";